import React from 'react';
import './ComponentToPrint.css';
import { QRCode } from 'react-qr-svg';
import { Box } from '@material-ui/core';

class ComponentToPrintCard extends React.Component {

  datePrint() {
    const today = new Date();
    today.setFullYear(today.getFullYear() + 1);
    today.setDate(today.getDate() + 1);
    const dd = today.getDate().toString().padStart(2, '0');
    const mm = (today.getMonth() + 1).toString().padStart(2, '0');
    const yyyy = today.getFullYear().toString().slice(-2);
    return `${dd}.${mm}.${yyyy}`;
  }

  render() {
    const { FirstName, LastName, PersonID, CustomerID } = this.props.Person;
    const date = this.datePrint();

    return (
      <Box
        sx={{
          width: '8.60cm',
          height: '5.40cm',
          border: '1px solid #ccc',
          borderRadius: '0.2cm',
          display: 'flex',
          flexDirection: 'row-reverse',
          padding: '0.3cm',
          boxShadow: 2,
          fontFamily: 'Arial, sans-serif',
          fontSize: '12pt',
          position: 'relative',
        }}
      >
        <Box sx={{
          position: 'absolute',
          top: '1cm',
          right: '5.5cm',
          width: '2.30cm',
          height: '2.30cm',
        }}>
          <QRCode
            level="L"
            style={{ width: '100%', height: '100%' }}
            value={JSON.stringify({ PersonID, CustomerID })}
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '0.15cm',
            mr: '0.32cm',
            mt: '0.71cm',
            whiteSpace: 'pre', 
          }}
        >
          <Box>
            <span style={{ color: 'transparent' }}>שם:   </span>{FirstName}
          </Box>
          <Box>
            <span style={{ color: 'transparent' }}>משפחה:: </span>{LastName}
          </Box>
          <Box>
            <span style={{ color: 'transparent' }}>ת.ז:    </span>{PersonID}
          </Box>
          <Box>
            <span style={{ color: 'transparent' }}>מס חבר:: </span>{CustomerID}
          </Box>
        </Box>


        <Box
          sx={{
            position: 'absolute',
            bottom: '0.5cm',
            right: '0.8cm',
          }}
        >
          <span style={{ color: 'transparent' }}> בתוקף עד: </span>{date}
        </Box>
      </Box>
    );
  }
}

export default ComponentToPrintCard;
